import React from "react";
import { IoCloudUpload } from "react-icons/io5";
import "./UploadStatus.css";

const UploadStatus = () => {
  return (
    <div className="upload-status">
      <div className="upload-icon-wrapper">
        <IoCloudUpload className="upload-icon" />
        <div className="upload-pulse"></div>
      </div>
      <span className="upload-text">Uploading Answer Sheet</span>
    </div>
  );
};

export default UploadStatus;
